import DOOR_ASSORTMENTS from './doorAssortment.graphql'

export default DOOR_ASSORTMENTS
